import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import firebase from "firebase/app";
import { fecha, timestampToDate } from "../../../../../services/utils";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "20px",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
    backgroundColor: "#e0e0e0",
  },
}));

export default function CheckChip(props) {
  const dispatch = useDispatch();
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const checkChip = useSelector((state) => state.events.checkChip);
  const eventConfiguration = useSelector(
    (state) => state.events.eventConfiguration
  );

  const classes = useStyles();
  const eventParticipantsList = useSelector(
    (state) => state.registry.eventParticipants
  );
  const eventParticipantsRequested = useSelector(
    (state) => state.registry.eventParticipantsRequested
  );
  const eventParticipantsEventIndex = useSelector(
    (state) => state.registry.eventParticipantsEventIndex
  );

  const eventSubEventsRegistry = useSelector(
    (state) => state.events.eventSubEventsRegistry
  );
  const eventSubEvents = useSelector((state) => state.events.eventSubEvents);
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );

  function getParticipantData(numero) {
    console.log(numero);
    if (
      Object.values(eventParticipantsList).filter((a) => a.numero === numero)
        .length > 0
    ) {
      const participant = Object.values(eventParticipantsList).filter(
        (a) => a.numero === numero
      )[0];
      return getModGenCat(eventSubEventsRegistry, participant);
    } else {
      return {
        numero: numero,
        nombres: "No encontrado",
        apellidos: "",
        genero: "NA",
        categoria: "na",
        modalidad: "NA"
      };
    }
  }

  // Llave del participante (no el número de dorsal) para poder escribir en
  // inscritos/listadoInscritos/{participanteId}/entregaKit/ — mismo nodo
  // que usa DetalleParticipante.jsx al marcar un kit entregado a mano.
  function encontrarParticipanteIdPorNumero(numero) {
    return Object.keys(eventParticipantsList || {}).find(
      (key) => eventParticipantsList[key].numero === numero
    );
  }


  function getModGenCat(subEventsRegistry, participant) {
    let mod = "";
    let cat = "";

    if (
      subEventsRegistry &&
      subEventsRegistry["modalidad_" + participant.modalidad]
    ) {
      mod =
        subEventsRegistry["modalidad_" + participant.modalidad]
          .descripcionModalidad;
    }

    if (
      subEventsRegistry &&
      subEventsRegistry["modalidad_" + participant.modalidad] &&
      subEventsRegistry["modalidad_" + participant.modalidad].ramaCat[
      "rama_" + participant.rama
      ] &&
      subEventsRegistry["modalidad_" + participant.modalidad].ramaCat[
        "rama_" + participant.rama
      ].categorias["categoria_" + participant.categoria]
    ) {
      cat =
        subEventsRegistry["modalidad_" + participant.modalidad].ramaCat[
          "rama_" + participant.rama
        ].categorias["categoria_" + participant.categoria].nombreCategoria;
    }

    return { ...participant, mod: mod, cat: cat, genero: participant.rama };
  }

  const checkChipOrder = checkChip
    ? Object.entries(checkChip)
        .map(([key, val]) => ({ ...val, _key: key }))
        .sort((a, b) => b.timeStamp - a.timeStamp)
    : [];
  const firstItem =
    checkChipOrder && checkChipOrder.length > 0
      ? getParticipantData(checkChipOrder[0].numero)
      : false;

  // Al habilitarlo en la configuración (checkChipConfig/marcarEntregaKit),
  // cada vez que esta pantalla muestra un chip NUEVO (no en cada render),
  // se marca automáticamente como entregado en Entrega de Kits — mismo
  // objeto "entrega" que escribe DetalleParticipante.jsx al marcar un kit a
  // mano, pero sin atribuirlo al atleta ni a otra persona
  // (recibeAtleta: false, recibePersona fijo indicando que fue por lectura
  // de chip), para no inventar quién lo recibió físicamente.
  const marcarEntregaKitHabilitado =
    eventConfiguration &&
    eventConfiguration.timingConfig &&
    eventConfiguration.timingConfig.checkChipConfig &&
    eventConfiguration.timingConfig.checkChipConfig.marcarEntregaKit;

  const ultimoChipProcesadoRef = useRef(null);

  useEffect(() => {
    console.log("[CheckChip entregaKit] efecto disparado. marcarEntregaKitHabilitado =", marcarEntregaKitHabilitado);
    if (!marcarEntregaKitHabilitado) {
      console.log("[CheckChip entregaKit] detenido: la opción no está habilitada en configuración");
      return;
    }
    const nuevo = checkChipOrder[0];
    if (!nuevo) {
      console.log("[CheckChip entregaKit] detenido: no hay ningún chip leído todavía");
      return;
    }
    if (nuevo._key === ultimoChipProcesadoRef.current) {
      console.log("[CheckChip entregaKit] detenido: este chip ya se procesó en este montaje (_key repetida)", nuevo._key);
      return;
    }
    ultimoChipProcesadoRef.current = nuevo._key;
    console.log("[CheckChip entregaKit] procesando chip nuevo", { _key: nuevo._key, numero: nuevo.numero, tipoNumero: typeof nuevo.numero });

    const participanteId = encontrarParticipanteIdPorNumero(nuevo.numero);
    console.log("[CheckChip entregaKit] participanteId encontrado:", participanteId);
    if (!participanteId) {
      console.log(
        "[CheckChip entregaKit] detenido: no se encontró ningún participante con numero ===",
        nuevo.numero,
        "revisa que el tipo (string/number) coincida con eventParticipantsList"
      );
      return;
    }
    const participante = eventParticipantsList[participanteId];

    const itemConfig =
      (registryConfiguration &&
        registryConfiguration.configuracion &&
        registryConfiguration.configuracion.entregaKits &&
        registryConfiguration.configuracion.entregaKits.items &&
        registryConfiguration.configuracion.entregaKits.items.item_1) || {
        code: "item_1",
        name: "Kit",
      };
    console.log("[CheckChip entregaKit] itemConfig:", itemConfig);

    const yaEntregado =
      participante.entregaKit &&
      Object.values(participante.entregaKit).some(
        (e) => e.item && e.item.code === itemConfig.code
      );
    console.log("[CheckChip entregaKit] entregaKit actual del participante:", participante.entregaKit, "yaEntregado:", yaEntregado);
    if (yaEntregado) {
      console.log("[CheckChip entregaKit] detenido: ya tenía una entrega registrada para este item, no se duplica");
      return;
    }

    const timestamp = new Date().getTime();
    const entrega = {
      iduser: null,
      nombresUser: "Checa Chip",
      apellidosUser: "",
      date: timestamp,
      item: itemConfig,
      recibeAtleta: false,
      recibePersona: "Entregado por lectura de Checa Chip",
      scanner: false,
      itemFormData: {},
    };

    const eventoIndex = "evento_" + eventDetail.iDEvento;

    // Mismo patrón que guardarEntrega() en Kits/DetalleParticipante.jsx (el
    // módulo real de entrega de kits): además de entregaKit, se agrega una
    // entrada a la bitácora de cambios del participante (changesRegistry),
    // mismo código de acción (12, "Entrega de kit") que ya usa ese módulo.
    const changesRegistry = {
      ...participante.changesRegistry,
      [timestamp + "_ts"]: {
        iduser: null,
        nombresUser: "Checa Chip",
        apellidosUser: "",
        action: 12,
        description: `Entrega de kit: ${itemConfig.name}`,
        date: timestamp,
      },
    };

    const updates = {};
    const path = `eventosCompletos/${eventoIndex}/inscritos/listadoInscritos/${participanteId}/entregaKit/${timestamp}_ts`;
    updates[path] = entrega;
    updates[
      `eventosCompletos/${eventoIndex}/inscritos/listadoInscritos/${participanteId}/changesRegistry`
    ] = changesRegistry;
    console.log("[CheckChip entregaKit] escribiendo en:", path, entrega);

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() => console.log("[CheckChip entregaKit] escritura exitosa"))
      .catch((err) => console.error("[CheckChip entregaKit] ERROR al escribir:", err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkChipOrder[0] && checkChipOrder[0]._key, marcarEntregaKitHabilitado]);
  const remainingItems =
    checkChipOrder && checkChipOrder.length > 1
      ? checkChipOrder.slice(1)
      : false;

  const backgroundImage =
    eventConfiguration &&
      eventConfiguration.timingConfig &&
      eventConfiguration.timingConfig.checkChipConfig &&
      eventConfiguration.timingConfig.checkChipConfig.checkChipImage
      ? eventConfiguration.timingConfig.checkChipConfig.checkChipImage
      : "";
  const checkChipFontColor =
    eventConfiguration &&
      eventConfiguration.timingConfig &&
      eventConfiguration.timingConfig.checkChipConfig &&
      eventConfiguration.timingConfig.checkChipConfig.checkChipFontColor
      ? eventConfiguration.timingConfig.checkChipConfig.checkChipFontColor
      : "#fff";
  const checkChipBackgroundColor =
    eventConfiguration &&
      eventConfiguration.timingConfig &&
      eventConfiguration.timingConfig.checkChipConfig &&
      eventConfiguration.timingConfig.checkChipConfig.checkChipImage
      ? eventConfiguration.timingConfig.checkChipConfig.checkChipBackgroundColor
      : "#fff";
  const checkChipPositionVertical =
    eventConfiguration &&
      eventConfiguration.timingConfig &&
      eventConfiguration.timingConfig.checkChipConfig &&
      eventConfiguration.timingConfig.checkChipConfig.checkChipPositionVertical
      ? eventConfiguration.timingConfig.checkChipConfig
        .checkChipPositionVertical
      : 0;
  const imageheight = 800 * 0.75;
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="center"
      style={{ padding: 0, backgroundColor: checkChipBackgroundColor }}
    >
      <Grid item xs={12} sm={7}>
        {/* Primer elemento destacado */}
        <Box
          style={{
            border: "3px solid #ef4122",
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "10px",
            padding: "15px",
            color: checkChipFontColor,
            textAlign: "center",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
            backgroundImage: `url(${backgroundImage})`,
            backgroundRepeat: "no-repeat",
            height: imageheight,
            width: (imageheight / 8) * 10,
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="center"
            style={{
              marginTop: checkChipPositionVertical * (imageheight / 2),
            }}
          >
            {/* Número destacado */}
            <Grid item xs={12}>
              <Typography
                variant="h2"
                style={{
                  fontWeight: "bold",
                  color: checkChipFontColor,
                  textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)",
                }}
              >
                Dorsal: {firstItem.numero}
              </Typography>
            </Grid>
            {/* Nombres y Apellidos */}
            <Grid item xs={12}>
              <Typography
                variant="h2"
                style={{
                  fontWeight: "600",
                  color: checkChipFontColor,
                  textShadow: "1px 1px 4px rgba(0, 0, 0, 0.7)",
                }}
              >
                {firstItem && `${firstItem.nombres.toUpperCase()} ${firstItem.apellidos.toUpperCase()}`}
              </Typography>
            </Grid>
            {/* Datos secundarios */}
            <Grid item xs={12}>
              <Typography
                variant="h4"
                style={{
                  color: checkChipFontColor,
                }}
              >
                Género: {firstItem.genero} | Categoría: {firstItem.cat} |
                Modalidad: {firstItem.mod}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={12}>
        {/* Tabla para los demás elementos */}
        <TableContainer component={Paper} style={{ margin: "15px" }}>
          <Table size="small">
            <TableBody>
              {remainingItems &&
                remainingItems.length > 0 &&
                remainingItems.map((item1, index) => {
                  const item = getParticipantData(item1.numero);
                  return (
                    <TableRow key={index}>
                      <TableCell
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#ef4122",
                        }}
                      >
                        Número: {item.numero}
                      </TableCell>
                      <TableCell style={{ fontSize: "14px", color: "#000" }}>
                        {item.nombres} {item.apellidos}
                      </TableCell>
                      <TableCell style={{ fontSize: "14px", color: "#000" }}>
                        Género: {item.genero}
                      </TableCell>
                      <TableCell style={{ fontSize: "14px", color: "#000" }}>
                        Categoría: {item.cat}
                      </TableCell>
                      <TableCell style={{ fontSize: "14px", color: "#000" }}>
                        Modalidad: {item.mod}
                      </TableCell>
                      <TableCell style={{ fontSize: "14px", color: "#000" }}>
                        Hora: {timestampToDate(item1.timeStamp)}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}
